import { motion } from "framer-motion";
import { Check, PiggyBank, Tag } from "lucide-react";
import { PRICING } from "@/data/content";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Pricing = () => {
  return (
    <section
      id="cennik"
      data-testid="pricing-section"
      className="relative overflow-hidden bg-[#2D3728] py-20 text-white md:py-32"
    >
      <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-[#4A7055]/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-[#9C5E4B]/20 blur-3xl" />

      <div className="relative mx-auto max-w-6xl px-5 md:px-10">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#E8D9B5]">
            {PRICING.eyebrow}
          </span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-balance md:text-4xl lg:text-5xl">
            {PRICING.title}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex flex-col justify-center rounded-3xl border border-white/15 bg-white/5 p-8 backdrop-blur-sm md:p-10"
          >
            <div className="flex items-end gap-2">
              <span
                data-testid="price-value"
                className="font-display text-5xl font-semibold text-[#E8D9B5] md:text-6xl"
              >
                {PRICING.price}
              </span>
              <span className="mb-2 text-lg text-white/70">
                {PRICING.period}
              </span>
            </div>
            <p className="mt-3 text-base text-white/80">{PRICING.note}</p>

            <div className="mt-6 space-y-3">
              <div className="flex items-start gap-3 rounded-xl bg-[#4A7055]/25 p-4">
                <Tag className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#E8D9B5]" />
                <p className="text-sm text-white/90">{PRICING.discount}</p>
              </div>
              <div className="flex items-start gap-3 rounded-xl bg-white/5 p-4">
                <PiggyBank className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#E8D9B5]" />
                <p className="text-sm text-white/80">{PRICING.deposit}</p>
              </div>
            </div>

            <button
              data-testid="pricing-cta"
              onClick={() => scrollTo("#kontakt")}
              className="mt-7 rounded-full bg-[#E8D9B5] px-8 py-4 text-sm font-semibold text-[#2D3728] transition-all hover:bg-white hover:-translate-y-0.5"
            >
              Zapytaj o wolny termin
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="rounded-3xl bg-white/5 p-8 backdrop-blur-sm md:p-10"
          >
            <h3 className="font-display text-xl font-semibold text-[#E8D9B5]">
              W cenie otrzymujesz
            </h3>
            <ul className="mt-6 space-y-3">
              {PRICING.inclusions.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#4A7055]">
                    <Check className="h-3 w-3 text-white" />
                  </span>
                  <span className="text-sm text-white/85">{item}</span>
                </li>
              ))}
            </ul>
            <p className="mt-6 rounded-xl border border-[#E8D9B5]/30 bg-[#E8D9B5]/10 p-4 text-center text-sm font-semibold text-[#E8D9B5]">
              {PRICING.noHidden}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
